import React from 'react';

const defaultValue = {
  slim: false
};

const SideNavContext = React.createContext(defaultValue);

export { SideNavContext as default };
